import * as Yup from 'yup';
import { transactionUserRelationshipKeys } from 'src/pages/transactions/constants';
import { requiredString } from 'src/utils/schemas';

export const validationSchema = Yup.object().shape({
	relationship: requiredString.oneOf([...transactionUserRelationshipKeys, 'other', 'updated-seller-name']),
});
